import { render, staticRenderFns } from "./DeptHelpList.vue?vue&type=template&id=3b747ae9&"
import script from "./DeptHelpList.vue?vue&type=script&lang=js&"
export * from "./DeptHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports